import request from '@/apis/request'
const resource = 'power-ball' 

export default {
  getRoom: (params) => {
    return request.get(`${resource}/room`,{params})
  }, 

  getStakes: (params) => { 
    return request.get(`${resource}/stakes`, { params })
  },

  roomHistory: { 
    gets: (params) => { 
      return request.get(`${resource}/room-history`, { params })
    },
    getById: (id, params) => { 
      return request.get(`${resource}/room-history/${id}`, { params })
    },
    rannking: {
      gets: (id,params) => { 
        return request.get(`${resource}/room-history/${id}/ranking`, { params })
      },
    }
  },
  

  stake: (id,params) => { 
    return request.post(`${resource}/room/${id}/st`, params)
  },
}